import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import '../../scss/popups/listdownload.scss';
import closeIcon from '../../images/popups/upload/closeicon.png';
import { CSVLink } from "react-csv";
import Calender from '../Reusables/Calender';
import { convertToDateString } from '../Reusables/Function';

function ListDownload(props) {
    const {showdownload, handleHideDownload, setDownloadtype, downloadtype, downloadarray, headers, filename, downloadDate, setDownloadDate} = props;
    const [fromlabel, setFromLabel] = useState('From');
    const [tolabel, setToLabel] = useState('To');

    function HandleRadio(e) {
        if(e.target.checked === true) {
            setDownloadtype(e.target.value);
        }
    }
    useEffect(() => {
        if(document.querySelector(`input[value='${downloadtype}']`)) {
            document.querySelector(`input[value='${downloadtype}']`).checked = true;
        }
    }, [downloadtype, showdownload])

    useEffect(() => {
        if(downloadDate) {
            setFromLabel(downloadDate.from ?? 'From');
            setToLabel(downloadDate.to ?? 'To');
        }
    }, [downloadDate])

    return (
            <Modal
                show={showdownload}
                onHide={handleHideDownload} className='download-popup'
                centered>
                <Modal.Body className='download-body'>
                    <div className='close-icon'>
                        <img src={closeIcon} onClick={handleHideDownload}/>
                    </div>
                    <div className='download-content'>
                        <div className='download-for'>
                            Download For
                        </div>
                        <div className='download-details'>
                            <div className='radio-button'>
                                <input type="radio" id="today" name='radio' value="today" onChange={(e) => HandleRadio(e)}/>
                                <label for="today">Today</label>
                            </div>
                            <div className='radio-button'>
                                <input type="radio" id="week" name='radio' value="week" onChange={(e) => HandleRadio(e)}/>
                                <label for="week">This Week</label>
                            </div>
                            <div className='radio-button'>
                                <input type="radio" id="month" name='radio' value="month" onChange={(e) => HandleRadio(e)}/>
                                <label for="month">This Month</label>
                            </div> <div className='radio-button'>
                                <input type="radio" id="30days" name='radio' value="30days" onChange={(e) => HandleRadio(e)}/>
                                <label for="30days">Last 30 Days</label>
                            </div> <div className='radio-button'>
                                <input type="radio" id="year" name='radio' value="year" onChange={(e) => HandleRadio(e)}/>
                                <label for="year">This Year</label>
                            </div>
                            <div className='radio-button'>
                                <input type="radio" id="custom" name='radio' value="custom" onChange={(e) => HandleRadio(e)}/>
                                <label for="custom">Custom Date</label>
                            </div>
                        </div>
                        
                        {downloadtype == 'custom' && <div className='d-flex align-items-center justify-content-center gap-5 mt-4 w-75'>
                            <div className='w-100 position-relative'>
                            <Calender minDate={false} maxDate={false} startdate={downloadDate.from} 
                                HandleDate={(date) => setDownloadDate({ from: date, to: null })} 
                                HandleLabel={(date) => setFromLabel(convertToDateString(date, "picker"))} label={fromlabel}
                                disablefromto={false} disableto={false} 
                            />
                            </div>
                            <div className='w-100 position-relative'><Calender minDate={downloadDate.from} maxDate={false} startdate={downloadDate.to} 
                                 HandleDate={(date) => setDownloadDate({...downloadDate, to: date})} 
                                HandleLabel={(date) => setToLabel(convertToDateString(date, "picker"))} label={tolabel}
                                disablefromto={false} disableto={false} 
                            /></div>
                        </div>}
                        
                        <div className={`download-button`}>
                            <CSVLink data={downloadarray} headers={headers} filename={filename} 
                                onClick={(event) => {
                                if ((!downloadDate.from || !downloadDate.to) && downloadtype == 'custom') {
                                    event.preventDefault(); // stops download
                                }
                                }}
                            >
                                <button style={downloadtype == 'custom' ? {background: downloadDate.from && downloadDate.to ? '#44A3D9' : '#ced4da', cursor: downloadDate.from && downloadDate.to ? 'pointer' : 'not-allowed'} : {}}>Download</button>
                            </CSVLink>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
    );
}

export default ListDownload;